<main-header [darkMode]="true"></main-header>
<main class="pt-24 md:pt-36 pb-12 md:pb-24 page-max-width page-default-padding">
  <router-outlet></router-outlet>
</main>
<main-footer></main-footer>
